/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import ConnectionStatus from '@linc-technologies/linced-common/enums/connection-status';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class WondeController extends Controller {
  @service
  session;

  @service
  router;

  @service
  toaster;

  @computed('model.connection.status')
  get isWondeSchool() {
    if (isEmpty(this.model.connection)) {
      return false;
    }
    return this.model.connection.status === ConnectionStatus.APPROVED;
  }

  @action
  updateSyncEnabled(syncEnabled) {
    this.model.connection.setProperties({
      syncEnabled: syncEnabled,
    });
    this.model.connection.save();
  }

  @action
  updatePeriodicSyncEnabled(periodicSyncEnabled) {
    this.model.connection.setProperties({
      periodicSyncEnabled: periodicSyncEnabled,
    });
    this.model.connection.save();
  }
}
